// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"styles_inputContainer___wZbd","checkbox":"styles_checkbox__wfe8y","label":"styles_label__r_hLj"};